<template>
  <div style="width:100%;">
    <v-expansion-panel-content v-for="(item, i) in itemData" :key="i">
      <template v-slot:header>
        <span v-if="!!item.SourceDetail">
          <b>{{ $t('WaterQualityAnalyteGuidelineUnitMismatchErrorModal.guidelineShortName') }}:</b>
          {{ item.SourceDetail.GuidelineShortName }}
          <b>{{ $t('WaterQualityAnalyteGuidelineUnitMismatchErrorModal.guidelineStandard') }}:</b>
          {{ item.SourceDetail.GuidelineStandard }}
          <b>{{ $t('WaterQualityAnalyteLabResultUnitMismatchErrorModal.analyte') }}:</b>
          {{ item.SourceDetail.AnalyteName }}
        </span>
        <span v-else>
          {{ item.Message }}
        </span>
      </template>
      <v-layout row wrap class="error-detail-body" v-if="!!item.SourceDetail">
        <v-flex xs4 class="border-bottom border-right">{{ $t('WaterQualityAnalyteGuidelineUnitMismatchErrorModal.analyteUnitGroup') }}</v-flex>
        <v-flex xs8 class="border-bottom">{{ item.SourceDetail.AnalyteUnitGroup }}</v-flex>
        <v-flex xs4 class="border-bottom border-right">{{ $t('WaterQualityAnalyteGuidelineUnitMismatchErrorModal.guidelineStandardUnit') }}</v-flex>
        <v-flex xs8 class="border-bottom">{{ item.SourceDetail.GuidelineStandardUnit }}</v-flex>
        <v-flex xs4 class="border-right">{{ $t('WaterQualityAnalyteGuidelineUnitMismatchErrorModal.message') }}</v-flex>
        <v-flex xs8>{{ item.Message }}</v-flex>
      </v-layout>
    </v-expansion-panel-content>
    <v-divider />
  </div>               
</template>

<script>
export default {
  props: {
    itemData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
    }
  },
}
</script>

<style scoped>
  .error-detail-body {
    padding: 12px 24px;
  }
  .border-bottom{
    border-bottom: 1px solid gray;
  }
  .border-right{
    border-right: 1px solid gray;
  }
</style>